export function timeToSlot(time: Date): number {
  const minuteOfDay = time.getHours() * 60 + time.getMinutes()
  return Math.floor(minuteOfDay / 15) - 24 // We start the day at 6:00AM
}
export function slotToTime(timeslot: number, date?: Date): Date {
  const hour = Math.floor(timeslot / 4) + 6
  const minute = (timeslot % 4) * 15
  const dateTime = date ?? new Date()
  dateTime.setHours(hour, minute, 0, 0)
  return dateTime
}
export function durationMinutesToSlots(duration: number): number {
  return Math.ceil(duration / 15)
}

export function timeSlotToString(timeslot: number): string {
  const hour = Math.floor(timeslot / 4) + 6
  const minute = (timeslot % 4) * 15
  return `${hour}:${String(minute).padStart(2, '0')}`
}